var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66667 11.9167H9.16667C9.67083 11.9167 10.0833 11.5042 10.0833 11V3.66667C10.0833 3.1625 9.67083 2.75 9.16667 2.75H3.66667C3.1625 2.75 2.75 3.1625 2.75 3.66667V11C2.75 11.5042 3.1625 11.9167 3.66667 11.9167ZM3.66667 19.25H9.16667C9.67083 19.25 10.0833 18.8375 10.0833 18.3333V14.6667C10.0833 14.1625 9.67083 13.75 9.16667 13.75H3.66667C3.1625 13.75 2.75 14.1625 2.75 14.6667V18.3333C2.75 18.8375 3.1625 19.25 3.66667 19.25ZM12.8333 19.25H18.3333C18.8375 19.25 19.25 18.8375 19.25 18.3333V11C19.25 10.4958 18.8375 10.0833 18.3333 10.0833H12.8333C12.3292 10.0833 11.9167 10.4958 11.9167 11V18.3333C11.9167 18.8375 12.3292 19.25 12.8333 19.25ZM11.9167 3.66667V7.33333C11.9167 7.8375 12.3292 8.25 12.8333 8.25H18.3333C18.8375 8.25 19.25 7.8375 19.25 7.33333V3.66667C19.25 3.1625 18.8375 2.75 18.3333 2.75H12.8333C12.3292 2.75 11.9167 3.1625 11.9167 3.66667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.6faf55b636821468d04c59f14db5dcac.svg";
export { ForwardRef as ReactComponent };